import lottie from "lottie-web";
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    svg: {
      type: Object,
      default: {}
    },

  }

  connect() {
    lottie.loadAnimation({
      container: this.element,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: this.svgValue,
    });
    this.svgValue = {}
  }


}
